import { render, staticRenderFns } from "./ToolsTab.vue?vue&type=template&id=5f61e2c6&"
import script from "./ToolsTab.vue?vue&type=script&lang=js&"
export * from "./ToolsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports